import React from "react";
import { FaRegFileAlt, FaRegStar, FaTrash, FaSquare } from "react-icons/fa";

const NotesSidebar = ({ activeTab, setActiveTab }) => {
  return (
    <div className="notes-sidebar">
      
      {/* HEADER */}
      <div className="sidebar-header">
        <h5>
          <FaRegFileAlt className="me-2" />
          Notes List
        </h5>
      </div>

      {/* MENU */}
      <div className="sidebar-menu">
        <button
          className={`menu-item ${activeTab === "all" ? "active" : ""}`}
          onClick={() => setActiveTab("all")}
        >
          <FaRegFileAlt className="icon" />
          <span>All Notes</span>
          <span className="count">1</span>
        </button>

        <button
          className={`menu-item ${activeTab === "important" ? "active" : ""}`}
          onClick={() => setActiveTab("important")}
        >
          <FaRegStar className="icon" />
          <span>Important</span>
        </button>

        <button
          className={`menu-item ${activeTab === "trash" ? "active" : ""}`}
          onClick={() => setActiveTab("trash")}
        >
          <FaTrash className="icon" />
          <span>Trash</span>
        </button>
      </div>

      {/* TAGS */}
      <div className="sidebar-section">
        <h6>Tags</h6>

        <div className="tag-item text-primary">
          <FaSquare className="tag-icon blue" />
          Pending
        </div>

        <div className="tag-item text-danger">
          <FaSquare className="tag-icon red" />
          Onhold
        </div>

        <div className="tag-item text-warning">
          <FaSquare className="tag-icon yellow" />
          Inprogress
        </div>

        <div className="tag-item text-success">
          <FaSquare className="tag-icon green" />
          Done
        </div>
      </div>

      {/* PRIORITY */}
      <div className="sidebar-section">
        <h6>Priority</h6>

        <div className="tag-item text-warning">
          <FaSquare className="tag-icon yellow" />
          Medium
        </div>

        <div className="tag-item text-success">
          <FaSquare className="tag-icon green" />
          High
        </div>

        <div className="tag-item text-danger">
          <FaSquare className="tag-icon red" />
          Low
        </div>
      </div>
      <style>
          {
               `
               .notes-sidebar {
  background: #fff;
  border-radius: 12px;
  padding: 18px;
  border: 1px solid #eee;
}

/* HEADER */
.sidebar-header {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.sidebar-header h5 {
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
}

/* MENU */
.sidebar-menu {
  border-bottom: 1px solid #eee;
  padding-bottom: 12px;
}

.menu-item {
  width: 100%;
  border: none;
  background: transparent;
  padding: 10px 12px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  font-size: 14px;
  color: #555;
  transition: 0.2s;
}

.menu-item .icon {
  font-size: 14px;
}

.menu-item .count {
  margin-left: auto;
}

/* ACTIVE (exact dark style) */
.menu-item.active {
  background: #1f2937;
  color: #fff;
}

/* SECTION */
.sidebar-section {
  margin-top: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 12px;
}

.sidebar-section:last-child {
  border-bottom: none;
}

.sidebar-section h6 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}

/* TAG ITEMS */
.tag-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  margin-bottom: 8px;
}

/* COLOR SQUARE */
.tag-icon {
  font-size: 10px;
}

.tag-icon.blue {
  color: #0d6efd;
}

.tag-icon.red {
  color: #dc3545;
}

.tag-icon.yellow {
  color: #ffc107;
}

.tag-icon.green {
  color: #198754;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .notes-sidebar {
    padding: 12px;
  }

  .menu-item {
    font-size: 13px;
    padding: 8px;
  }
}`
          }
      </style>
    </div>
  );
};

export default NotesSidebar;